import { MapTool } from "../enums";
import FieldProperties = __esri.FieldProperties;

export interface MapProperties {
  basemap: string;
}

export interface MapViewProperties {
  container?: string;
  map?: any;
  center: [number, number];
  zoom: number;
  popup?: any;
}

export interface FeatureLayerProperties {
  name: string;
  title: string;
  fields: FieldProperties[];
  objectIdField: string;
  geometryType: 'point' | 'multipoint' | 'polyline' | 'polygon' | 'multipatch' | 'mesh';
  spatialReference: { wkid: number };
  renderer: any;
  labelingInfo?: any;
  outFields?: any;
  refreshInterval?: number;
  opacity?: number;
  graphicAttr: string;
  attrId: string;
  exportable: boolean;
  graphicArray?: boolean;
  tools?: MapTool[],
  popupTemplate?: any;
  fieldsExport?: string[];
  shapeLinksExport?: string[];
}

// this is only a minimal subset
export interface ImageryLayerProperties {
  title: string;
  opacity: number;
  url: string;
  visible: boolean;
}

// this is only a minimal subset
export interface MapImageLayerProperties {
  title: string;
  opacity: number;
  url: string;
  visible: boolean;
}

export interface GPFeatureRecordSetLayer {
  geometryType?: 'esriGeometryPoint' | 'esriGeometryPolyline' | 'esriGeometryPolygon';
  fields?: FieldProperties[];
  spatialReference?: { wkid: number };
  features: any[];
}

export interface MapGeoProcessJob {
  name: string;
  slug: string;
  active: boolean;
  url: string;
  params: MapGeoProcessJobParam[];
  resultName: string;
  resultLabels: {key: string, label: string}[];
  content: any[];
}

export interface MapGeoProcessJobParam {
  name: string;
  value?: string;
  isGraphic?: string;
}

export interface MapGeoProcessJobResult {
  jobType: string;
  response: any;
}
